import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/quality',
    children: [
      { path: '', redirect: '/quality/home' },
      { path: 'home', name: 'quality-home', component: () => import('@/modules/quality/QualityHome.vue') },
      { path: 'iqc', name: 'quality-iqc', component: () => import('@/modules/quality/IqcIncoming.vue') },
      { path: 'ipqc', name: 'quality-ipqc', component: () => import('@/modules/quality/IpqcInspect.vue') },
      { path: 'fqc', name: 'quality-fqc', component: () => import('@/modules/quality/FqcRecords.vue') },
      { path: 'spc', name: 'quality-spc', component: () => import('@/modules/quality/SpcChart.vue') },
      { path: 'improvements', name: 'quality-improvements', component: () => import('@/modules/quality/ImprovementsList.vue') }
    ]
  }
]

export default routes
